import { LocationRead } from "@types";
import { Button } from "primereact/button";
import { useGetLocationsProps } from "./types";
import Defaults from "../../../../assets/label-2160913_640.webp";

export const useGetLocations = ({ onEdit }: useGetLocationsProps) => {
  const columns = [
    {
      field: "image",
      header: "",
      body: (rowData: LocationRead) => {
        return (
          <div className="max-w-6rem max-h-6rem overflow-hidden">
            <img
              src={rowData.homePhotoUrl || Defaults}
              alt="promotion"
              className="w-full h-full object-cover"
            />
          </div>
        );
      },
    },

    { field: "locationName", header: "Location Name" },
    { field: "addressName", header: "Address" },
    { field: "city", header: "City" },
    { field: "state", header: "State" },
    { field: "zipCode", header: "Zip Code" },
    { field: "phone", header: "Phone" },
    {
      field: "edit",
      header: "Edit",
      body: (rowData: LocationRead) => (
        <div className="flex gap-2">
          <Button
            icon="pi pi-pencil"
            className="p-button-text p-button-sm"
            onClick={() => {
              onEdit(rowData);
            }}
          />
        </div>
      ),
    },
  ];

  return { columns };
};
